import { type MaybeRefOrGetter, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { getTariffById, listTariffsByUtilityId } from '@/api/utilities/utilities'

export function useUtilityTariffList(utilityId: MaybeRefOrGetter<number|undefined>) {
  return useQuery({
    enabled: () => {
      const resolvedId = toValue(utilityId)

      return resolvedId !== undefined && resolvedId > 0
    },
    queryKey: ['utilities:tariffs', utilityId],
    queryFn: () => listTariffsByUtilityId(toValue(utilityId)!)
  })
}

export const useTariffDetails = (tariffId: MaybeRefOrGetter<number|undefined>) => useQuery({
  queryKey: ['tariffs:details', tariffId],
  enabled: () => toValue(tariffId) !== undefined,
  queryFn: () =>  getTariffById(toValue(tariffId)!),
})
